




































































































































































































































































































































































































































































































































































































































































































































































































































































































































import { Vue, Component, Prop, Ref, Watch } from 'vue-property-decorator'
import { DictRequest, DictParam, DictFilter, DictOptions, VForm, Certificates } from '@/types'
import { EPLModule } from '@/store/eplmodule'
import { SIGNModule } from '@/store/signmodule'
import moment from 'moment'

@Component({
  name: 'EPLEditForm',
  components: {
    DictTable: () =>
      import(/* webpackChunkName: "DictTable" */ '@/components/DictTable.vue'),
    UIField: () =>
      import(
        /* webpackChunkName: "UIField" */ '@/components/UIField.vue'
      )
  }
})
export default class EPLEditForm extends Vue {
  @Prop(String) readonly id!: string
  @Prop(String) readonly taskid!: string

  dictName = 'EPL'
  show = false
  idx = -1
  idxS = -1
  idxR = -1
  idxC = -1
  idxDT = -1
  idxDt = -1
  idxRp = -1
  changed = false
  valid = true
  savedEPL = ''
  tab = 0
  activeTab = 0
  tabs = [] as {
    name: string,
    ext: string,
    icon: string,
    locked: boolean
  }[]

  myxml = [] as Array<{ key: string, val: string | null }>
  showSignXMLDialog = false
  showSignPDFDialog = false
  pdfFileName = ''
  pdfData = ''
  previewPDFsrc = ''
  previewHeight = 300
  showSignSimpleDialog = false
  iPassword = ''
  iLogin = ''
  loadingSimple = false
  loadingCert = false
  loadingPDF = false
  provider = ['']
  certificates = [] as Certificates
  XMLtoSign = ''
  signEventType = 0
  showCheckListDialog = false
  departuretotalmileage = ''
  departurewh = ''
  departuretotalmileagePrev = ''
  departurewhPrev = ''
  arrivedtotalmileage = ''
  arrivedwh = ''
  fuelfills = [] as Array<{ id: number, name: string, value: string, prev: string, get: boolean }>
  checkListValid = true
  checkListType = 0
  msgsHeight = 0
  message = ''
  messages = [] as any[]
  messageDisable = false
  driversId = [] as number[]
  interval = 0
  tablecard = 1

  filterEPL = {
    field: 'eplid',
    condition: this.id,
    operator: '=',
    combine: 'number'
  } as DictFilter

  filterJournal = {
    field: 'rowid',
    condition: this.id,
    operator: '=',
    combine: 'number'
  } as DictFilter

  @Ref('eplform') EPLForm!: VForm
  @Ref('checklistform') checkListForm!: VForm

  @Watch('id')
  onIDChange () {
    this.initEPL()
  }

  @Watch('currentRow', { deep: true })
  onEPLChange () {
    if (this.savedEPL === '') return
    const newEPL = JSON.stringify(EPLModule.dicts[this.idx].currentRow)
    this.changed = this.savedEPL !== newEPL
  }

  private setMessagesTimeout (): void {
    this.interval = setInterval(() => {
      if (!this.messageDisable) this.getMessages()
    }, 60000)
  }

  private getMessages () {
    const r = {} as DictRequest
    r.filter = [] as DictFilter[]
    r.options = {
      page: 1,
      itemsPerPage: -1,
      sortBy: ['date'],
      sortDesc: [false]
    }
    r.filter.push({
      field: 'recepient',
      condition: '0',
      operator: '=',
      combine: 'AND'
    })
    r.filter.push({
      field: 'dict',
      condition: 'EPL',
      operator: '=',
      combine: 'AND'
    })
    r.filter.push({
      field: 'rowid',
      condition: this.id,
      operator: '=',
      combine: 'AND'
    })
    EPLModule.getEPLMessage(JSON.stringify(r))
      .then((res: any) => {
        this.messages.splice(0, this.messages.length)
        if (res !== null) {
          this.messages = res
          this.scrollMessages()
        }
      })
  }

  private scrollMessages () {
    setTimeout(() => {
      const obj = this.$refs.messagesEnd as any
      if (obj !== undefined) {
        obj.scrollIntoView()
      }
    }, 100)
  }

  private async sendMessage () {
    if (this.message === '') return
    if (this.message.length > 200) return
    this.messageDisable = true
    if (this.driversId.length === 0) {
      if (EPLModule.dicts[this.idx].currentRow.driver1 !== '') {
        await EPLModule.dictFindField({ dict: 'Users', field: 'id', byfield: 'driverid', value: EPLModule.dicts[this.idx].currentRow.driver1 })
          .then((response: any) => {
            this.driversId.push(parseInt(response.data.str))
          })
      }
      if (EPLModule.dicts[this.idx].currentRow.driver2 !== '') {
        await EPLModule.dictFindField({ dict: 'Users', field: 'id', byfield: 'driverid', value: EPLModule.dicts[this.idx].currentRow.driver2 })
          .then((response: any) => {
            this.driversId.push(parseInt(response.data.str))
          })
      }
    }
    const p = []
    const authors = [] as number[]
    authors.push(...this.driversId)
    this.messages.forEach((m: any) => {
      if (m.autor !== this.user.id) {
        if (!authors.includes(m.autor)) {
          authors.push(m.autor)
        }
      }
    })
    const msg = { id: 0, rowid: parseInt(this.id), dict: 'EPL', recepient: 0, autor: this.user.id, message: '', date: moment().unix(), readed: false }
    msg.message = `${this.user.fio}#${this.message.replace(/[#]/ig, '')}`
    p.push(EPLModule.sendEPLMessage(JSON.stringify(msg)))
    authors.forEach((a: number) => {
      msg.recepient = a
      p.push(EPLModule.sendEPLMessage(JSON.stringify(msg)))
    })
    Promise.all(p).then(() => {
      msg.recepient = 0
      this.messages.push(msg)
      this.messageDisable = false
      this.message = ''
      this.scrollMessages()
    })
  }

  private reSize () {
    let k = 0
    k = 240
    this.msgsHeight = window.innerHeight - k
  }

  // beforeCreate () {
  //   console.log('beforeCreate')
  // }

  // created () {
  //   console.log('Created')
  // }

  mounted () {
    // console.log('mounted EPL form')
    this.reSize()
    window.addEventListener('resize', this.reSize)
    this.getMessages()
    this.idx = EPLModule.DictIdx('EPL')
    this.idxS = EPLModule.DictIdx('Signs')
    this.idxR = EPLModule.DictIdx('Roles')
    this.idxC = EPLModule.DictIdx('CheckListLines')
    this.idxDT = EPLModule.DictIdx('DriverTasks')
    this.idxDt = EPLModule.DictIdx('Downtimes')
    this.idxRp = EPLModule.DictIdx('Repairs')
    this.tabs = [
      {
        name: 'Информация',
        ext: '',
        icon: 'fas fa-info-circle',
        locked: false
      },
      {
        name: 'Задания',
        ext: 'водителю',
        icon: 'fas fa-list-alt',
        locked: EPLModule.dicts[this.idxDT].locked.read
      },
      {
        name: 'Простои',
        ext: 'Ремонты',
        icon: 'fas fa-pause',
        locked: EPLModule.dicts[this.idxDt].locked.read
      },
      {
        name: 'Контроль',
        ext: '',
        icon: 'fas fa-user-check',
        locked: EPLModule.dicts[this.idxS].locked.read
      },
      {
        name: 'Сообщения',
        ext: '',
        icon: 'fas fa-comment',
        locked: false
      }
    ]
    if (this.user.roleid === 1) {
      this.tabs.push({
        name: 'Действия',
        ext: '',
        icon: 'fas fa-users-cog',
        locked: false
      })
    }
    setTimeout(this.initEPL, 200)
    if (this.user.roleid === 2) {
      // если это контролёр, то загрузим данные о топливе и пошлём на вкладку контроля
      const idx = EPLModule.DictIdx('FuelFills')
      const p = {} as DictParam
      p.idx = idx
      p.request = {} as DictRequest
      p.request.options = { page: 1, itemsPerPage: -1 } as DictOptions
      p.request.filter = []
      p.request.filter.push(this.filterEPL)
      EPLModule.fetchDictData(p)
        .then(() => {
          this.activeTab = 3
        })
    }
    this.setMessagesTimeout()
  }

  beforeDestroy () {
    clearInterval(this.interval)
    this.interval = 0
  }

  get currentRow () {
    if (EPLModule.dicts[this.idx] === undefined) return []
    return EPLModule.dicts[this.idx].currentRow
  }

  get user () {
    return EPLModule.user
  }

  get dict () {
    return EPLModule.dicts[this.idx]
  }

  get dictR () {
    return EPLModule.dicts[this.idxR]
  }

  get dictS () {
    return EPLModule.dicts[this.idxS]
  }

  get dictC () {
    return EPLModule.dicts[this.idxC]
  }

  get lists () {
    return EPLModule.lists
  }

  get cantSign () {
    let cs = false
    this.dictR.rows.forEach(r => {
      // роль пользователя находится в списке ролей имеющих право подписи
      if (r.id === this.user.roleid) cs = true
    })
    return !cs
  }

  get allSigned () {
    // нужно чтобы каждый подписант поставил две подписи
    let count = 0
    let mustCount = 0
    this.dictR.rows.forEach(r => {
      if (r.signer) mustCount++
      this.dictS.rows.forEach(s => {
        if (s.role === r.id) count++
      })
    })
    return count === mustCount * 2
  }

  private getSelectValue (value: string | number, list: any): string {
    let result = ''
    if (EPLModule.lists[list]) {
      if (typeof value === 'string' && value.includes(' ')) {
        const values = value.split(' ')
        values.forEach(v => {
          EPLModule.lists[list].forEach((i: any) => {
            if (i.value === v) {
              result += i.text + ', '
            }
          })
        })
        result = result.substring(0, result.length - 2)
      } else {
        EPLModule.lists[list].forEach((i: any) => {
          if (i.value === value || i.value === `${value}`) {
            result = i.text
          }
        })
      }
    }
    return result
  }

  private viewSignPDF () {
    this.myxml.splice(0, this.myxml.length)
    this.showSignPDFDialog = true
    this.loadingCert = true
    this.loadingPDF = true
    EPLModule.downloadPDF(EPLModule.dicts[this.idx].currentRow.id)
      .then((response: any) => {
        const fr = new FileReader()
        this.previewHeight = window.innerHeight - 120
        this.previewPDFsrc = window.URL.createObjectURL(new Blob([response.data]))
        fr.readAsDataURL(new Blob([response.data]))
        fr.onloadend = (result: any) => {
          console.log('load')
          const header = ';base64,'
          const fd = result.target.result
          this.pdfData = fd.substr(fd.indexOf(header) + header.length)
          this.loadingPDF = false
        }
        EPLModule.downloadSigPDF(parseInt(this.id))
          .then(
            async (response: any) => {
              let sign = ''
              const fr = new FileReader()
              fr.readAsText(new Blob([response.data]))
              fr.onload = async (result: any) => {
                sign = result.target.result
                try {
                  this.provider = await SIGNModule.checkSignPDF({ data: this.pdfData, sign: sign })
                  this.loadingCert = false
                } catch (e) {
                  this.loadingCert = false
                  this.provider = [e]
                }
              }
            }
          )
      })
  }

  private async onSignPDF () {
    this.showSignPDFDialog = true
    this.loadingCert = true
    this.loadingPDF = true
    EPLModule.downloadPDF(EPLModule.dicts[this.idx].currentRow.id)
      .then((response: any) => {
        let filename = response.headers['content-disposition']
        filename = filename.substr(filename.search(/"/g) + 1)
        filename = filename.substr(0, filename.search(/"/g))
        const fr = new FileReader()
        this.previewHeight = window.innerHeight - 120
        this.previewPDFsrc = window.URL.createObjectURL(new Blob([response.data]))
        fr.readAsDataURL(new Blob([response.data]))
        fr.onloadend = (result: any) => {
          const header = ';base64,'
          const fd = result.target.result
          this.pdfFileName = filename
          this.pdfData = fd.substr(fd.indexOf(header) + header.length)
          this.loadingPDF = false
        }
      })
    try {
      const provider = await SIGNModule.checkProvider()
      this.provider = [provider]
      this.certificates = await SIGNModule.getCertificates()
      this.loadingCert = false
    } catch (e) {
      this.loadingCert = false
      this.provider = [e]
    }
  }

  private signPDF (thumbprint: string) {
    SIGNModule.signCades({ thumbprint: thumbprint, docName: this.pdfFileName, data: this.pdfData })
      .then((sign: string) => {
        const name = this.pdfFileName.replace('.pdf', '.sig')
        EPLModule.setSignPDFFile({ id: parseInt(this.id), data: sign, name: name })
          .then(() => {
            this.certificates = []
            this.showSignPDFDialog = false
            this.previewPDFsrc = ''
            this.initEPL()
          })
      })
  }

  private async signEPL (thumbprint: string) {
    if (thumbprint === '-') {
      // простая подпись
      this.loadingSimple = true
      EPLModule.setSignSimple({ id: parseInt(this.id), event: this.signEventType, login: this.iLogin, password: this.iPassword })
        .then((response) => {
          this.initEPL()
          this.showSignSimpleDialog = false
          this.loadingSimple = false
          console.log(response)
        })
        .catch(() => (this.loadingSimple = false))
    } else {
      // квалифицированная подпись
      let cert = ''
      this.certificates.forEach(c => {
        if (c.thumbprint === thumbprint) {
          const t = c.name.match(/T=([А-Яа-я\s]+),/)
          const sn = c.name.match(/SN=([А-Яа-я\s]+),/)
          const g = c.name.match(/G=([А-Яа-я\s]+),/)
          let tt = ''
          let tsn = ''
          let tg = ''
          if (t !== null) tt = t[1]
          if (sn !== null) tsn = sn[1]
          if (g !== null) tg = g[1]
          cert = `${tt}, ${tsn} ${tg}, № ${c.serial} действителен с ${c.fromdate} по ${c.todate}`
        }
      })
      await SIGNModule.signXML({ thumbprint: thumbprint, data: this.XMLtoSign })
        .then(sign => {
          EPLModule.setSignXMLFile({ id: parseInt(this.id), event: this.signEventType, cert: cert, data: sign })
        })
        .catch(e => {
          console.log(e)
          EPLModule.setError(e)
        })
      this.certificates = []
      this.showSignXMLDialog = false
      this.initEPL()
    }
  }

  private initEPL () {
    this.changed = false
    const p = {} as DictParam
    p.idx = this.idx
    p.request = {} as DictRequest
    p.request.options = { page: 1, itemsPerPage: 1 }
    p.request.filter = [{ field: 'id', condition: this.id, operator: '=' }]
    EPLModule.fetchDictData(p).then(() => {
      this.getMessages()
      EPLModule.showDictForm({ id: parseInt(this.id), idx: this.idx })
      // заполним фильтры для дочерних форм
      this.loadChildDict()
      // сохраним начальное состояние для определения изменений
      this.savedEPL = JSON.stringify(EPLModule.dicts[this.idx].currentRow)
    })
  }

  private loadChildDict () {
    const promises = [] as any
    // Roles
    const pr = {} as DictParam
    pr.idx = this.idxR
    pr.request = {} as DictRequest
    pr.request.options = { page: 1, itemsPerPage: 100 }
    pr.request.filter = []
    const fr = {} as DictFilter
    fr.field = 'signer'
    fr.condition = '1'
    fr.operator = '='
    pr.request.filter.push(fr)
    promises.push(EPLModule.fetchDictData(pr))
    // Signs
    const ps = {} as DictParam
    ps.idx = this.idxS
    ps.request = {} as DictRequest
    ps.request.options = { page: 1, itemsPerPage: 100 }
    ps.request.filter = []
    const fs = {} as DictFilter
    fs.field = 'eplid'
    fs.condition = this.id
    fs.operator = '='
    ps.request.filter.push(fs)
    promises.push(EPLModule.fetchDictData(ps))
    // CheckList
    const pc = {} as DictParam
    pc.idx = this.idxC
    pc.request = {} as DictRequest
    pc.request.options = { page: 1, itemsPerPage: 100 }
    pc.request.filter = []
    promises.push(EPLModule.fetchDictData(pc))
    Promise.all(promises).then(() => {
      // необходимо заблокировать подписанные поля
      EPLModule.blockSignedFields({ idx: this.idx, eplid: parseInt(this.id) })
      // сохранённый результат чеклиста
      const cl1 = EPLModule.dicts[this.idx].currentRow.checklist1
      if (cl1 !== undefined) {
        const ci = cl1.split(',')
        this.dictC.rows.forEach((c, i) => {
          // установим свичи в соответствии с сохранёнными
          let res = false
          ci.forEach((e: string) => {
            if (e === `${c.id}`) res = true
          })
          this.dictC.rows[i].result1 = res
        })
      }
      const cl2 = EPLModule.dicts[this.idx].currentRow.checklist2
      if (cl2 !== undefined) {
        const ci = cl2.split(',')
        this.dictC.rows.forEach((c, i) => {
          // установим свичи в соответствии с сохранёнными
          let res = false
          ci.forEach((e: string) => {
            if (e === `${c.id}`) res = true
          })
          this.dictC.rows[i].result2 = res
        })
      }
      if (this.taskid !== undefined) {
        // требется переход на форму Сменного задания
        this.activeTab = 1
        const p = {} as DictParam
        p.idx = this.idxDT
        p.request = {} as DictRequest
        p.request.options = { page: 1, itemsPerPage: 1 } as DictOptions
        p.request.filter = []
        p.request.filter.push(this.filterEPL)
        EPLModule.fetchDictData(p)
          .then(() => {
            let res = false
            EPLModule.dicts[this.idxDT].rows.forEach(r => {
              if (r.id === parseInt(this.taskid)) {
                res = true
                EPLModule.showDictForm({ id: parseInt(this.taskid), idx: this.idxDT })
              }
            })
            if (!res) {
              EPLModule.setError('Нет такого Сменного Задания в этом ЭПЛ')
            }
          })
      }
      this.show = true
    })
  }

  private viewSignXML (eventtype: number, roleid: number) {
    this.myxml.splice(0, this.myxml.length)
    this.showSignXMLDialog = true
    this.loadingCert = true
    EPLModule.getSignXMLFile({ id: parseInt(this.id), event: eventtype, role: roleid }).then(
      async (response: any) => {
        const parser = new DOMParser()
        const xmlDoc = parser.parseFromString(response.data, 'text/xml')
        const x = xmlDoc.documentElement.childNodes
        let val: string | null
        for (let i = 0; i < x.length; i++) {
          if (x[i].childNodes[0] === undefined) {
            val = ''
          } else {
            val = x[i].childNodes[0].nodeValue
          }
          this.myxml.push({ key: x[i].nodeName, val: val })
        }
        try {
          this.provider = await SIGNModule.checkSignXML(response.data)
          this.loadingCert = false
        } catch (e) {
          this.loadingCert = false
          this.provider = [e]
        }
      }
    )
  }

  private checkList (type: number) {
    this.checkListType = type
    const idx = EPLModule.DictIdx('FuelFills')
    this.fuelfills.splice(0, this.fuelfills.length)
    if (type === 0) {
      EPLModule.dicts[idx].rows.forEach(r => {
        let l = ''
        EPLModule.lists['FuelType-fuelname' as any].forEach(list => {
          if (list.value === r.fuelid) l = list.text
        })
        this.fuelfills.push({ id: r.fuelid, name: l, value: `${r.balancestart}`, prev: 'Неизвестно', get: false })
      })
      EPLModule.getPrevEPL({ id: this.id, uid: this.dict.currentRow.transport, time: this.dict.currentRow.departureplanetime })
        .then((res: any) => {
          this.departuretotalmileagePrev = `${res.data.arrivedtotalmileage}`
          this.departurewhPrev = `${res.data.arrivedwh}`
          res.data.fuelleft.forEach((p: any) => {
            this.fuelfills.forEach(f => {
              if (p.fuelid === f.id) f.prev = `${p.balancefinish}`
            })
          })
          this.departuretotalmileage = `${EPLModule.dicts[this.idx].currentRow.departuretotalmileage}`
          this.departurewh = `${EPLModule.dicts[this.idx].currentRow.departurewh}`
          this.showCheckListDialog = true
          setTimeout(() => { this.checkListForm.validate() }, 300)
        })
        .catch(() => {
          this.departuretotalmileagePrev = 'Неизвестно'
          this.departurewhPrev = 'Неизвестно'
          this.showCheckListDialog = true
          setTimeout(() => { this.checkListForm.validate() }, 300)
        })
    } else {
      EPLModule.dicts[idx].rows.forEach(r => {
        let l = ''
        EPLModule.lists['FuelType-fuelname' as any].forEach(list => {
          if (list.value === r.fuelid) l = list.text
        })
        this.fuelfills.push({ id: r.fuelid, name: l, value: `${r.balancefinish}`, prev: '', get: false })
        this.fuelfills.push({ id: r.fuelid, name: `${l} - заправка`, value: `${r.fuelget}`, prev: '', get: true })
      })
      this.arrivedtotalmileage = `${EPLModule.dicts[this.idx].currentRow.arrivedtotalmileage}`
      this.arrivedwh = `${EPLModule.dicts[this.idx].currentRow.arrivedwh}`
      this.showCheckListDialog = true
    }
  }

  private saveCheckList () {
    // сохраним id отмеченных свичей в поле ЭПЛ
    this.showCheckListDialog = false
    let res = ''
    if (this.checkListType === 0) {
      this.dictC.rows.forEach(c => {
        if (c.result1) res += `${c.id},`
      })
      EPLModule.dicts[this.idx].currentRow.checklist1 = res
    }
    if (this.checkListType === 1) {
      this.dictC.rows.forEach(c => {
        if (c.result2) res += `${c.id},`
      })
      EPLModule.dicts[this.idx].currentRow.checklist2 = res
    }
    this.fieldsCheckList()
  }

  private checkCheckList () {
    // отметим все и сохраним id отмеченных свичей в поле ЭПЛ
    this.showCheckListDialog = false
    let res = ''
    if (this.checkListType === 0) {
      this.dictC.rows.forEach(c => {
        c.result1 = true
        res += `${c.id},`
      })
      EPLModule.dicts[this.idx].currentRow.checklist1 = res
    }
    if (this.checkListType === 1) {
      this.dictC.rows.forEach(c => {
        c.result2 = true
        res += `${c.id},`
      })
      EPLModule.dicts[this.idx].currentRow.checklist2 = res
    }
    this.fieldsCheckList()
  }

  private fieldsCheckList () {
    const idx = EPLModule.DictIdx('FuelFills')
    if (this.checkListType === 0) {
      EPLModule.dicts[idx].rows.forEach((r, i) => {
        this.fuelfills.forEach(p => {
          const val = parseFloat(p.value)
          if ((r.eplid === parseInt(this.id)) && (r.fuelid === p.id)) {
            if (r.balancestart !== val) {
              EPLModule.dicts[idx].rows[i].balancestart = val
              EPLModule.saveDictRow({ id: r.id, idx })
            }
          }
        })
      })
      EPLModule.dicts[this.idx].currentRow.departuretotalmileage = parseFloat(this.departuretotalmileage)
      EPLModule.dicts[this.idx].currentRow.departurewh = parseFloat(this.departurewh)
    } else {
      EPLModule.dicts[idx].rows.forEach((r, i) => {
        this.fuelfills.forEach(p => {
          if ((r.eplid === parseInt(this.id)) && (r.fuelid === p.id)) {
            const val = parseFloat(p.value)
            if (p.get) {
              if (r.fuelget !== val) {
                EPLModule.dicts[idx].rows[i].fuelget = val
                EPLModule.saveDictRow({ id: r.id, idx })
              }
            } else {
              if (r.balancefinish !== val) {
                EPLModule.dicts[idx].rows[i].balancefinish = val
                EPLModule.saveDictRow({ id: r.id, idx })
              }
            }
          }
        })
      })
      EPLModule.dicts[this.idx].currentRow.arrivedtotalmileage = parseFloat(this.arrivedtotalmileage)
      EPLModule.dicts[this.idx].currentRow.arrivedwh = parseFloat(this.arrivedwh)
      EPLModule.dicts[this.idx].currentRow.whdiff = EPLModule.dicts[this.idx].currentRow.arrivedwh - EPLModule.dicts[this.idx].currentRow.departurewh
    }
    this.saveEPL()
  }

  get resultCheckList1 (): boolean {
    let result = true
    this.dictC.rows.forEach(c => {
      if (result) {
        if (c.critical && c.result1) {
          result = true
        } else if (!c.critical) {
          result = true
        } else {
          result = false
        }
      }
    })
    return result
  }

  get resultCheckList2 (): boolean {
    let result = true
    this.dictC.rows.forEach(c => {
      if (result) {
        if (c.critical && c.result2) {
          result = true
        } else if (!c.critical) {
          result = true
        } else {
          result = false
        }
      }
    })
    return result
  }

  private async onSign (eventtype: number, qsign: boolean) {
    this.signEventType = eventtype
    if (qsign) {
      // квалифицированная подпись
      this.myxml.splice(0, this.myxml.length)
      this.showSignXMLDialog = true
      this.loadingCert = true
      EPLModule.getSignXMLFile({ id: parseInt(this.id), event: eventtype, role: 0 }).then(
        (response: any) => {
          this.XMLtoSign = response.data
          const parser = new DOMParser()
          const xmlDoc = parser.parseFromString(response.data, 'text/xml')
          const x = xmlDoc.documentElement.childNodes
          let val: string | null
          for (let i = 0; i < x.length; i++) {
            if (x[i].childNodes[0] === undefined) {
              val = ''
            } else {
              val = x[i].childNodes[0].nodeValue
            }
            this.myxml.push({ key: x[i].nodeName, val: val })
          }
        }
      )
      try {
        const provider = await SIGNModule.checkProvider()
        this.provider = [provider]
        this.certificates = await SIGNModule.getCertificates()
        this.loadingCert = false
      } catch (e) {
        this.loadingCert = false
        this.provider = [e]
      }
    } else {
      // простая подпись
      this.iLogin = EPLModule.user.tabn
      this.showSignSimpleDialog = true
    }
  }

  private getDictField (idx: number, uid: string, field: string): string {
    let res = ''
    EPLModule.dicts[idx].rows.forEach(r => {
      if (r.uid === uid) res = r[field]
    })
    return res
  }

  private getSignBtn (): boolean {
    let qsign = false
    EPLModule.dicts[this.idxR].rows.forEach((s: any) => {
      if (s.id === this.user.roleid) qsign = s.qsign
    })
    return qsign
  }

  private getSignRow (role: number, eventtype: number, field: string): string {
    let res = ''
    EPLModule.dicts[this.idxS].rows.forEach((s: any) => {
      if (s.role === role && s.eventtype === eventtype) res = s[field]
    })
    return res
  }

  private isLockedField (name: string): boolean {
    // поле только для чтения если оно в списке исключений
    // но доступно для редактирования при создании новой записи
    let res = false
    const fields = EPLModule.dicts[this.idx].locked.fields
    const pos = fields.indexOf(name)
    if (pos === 0) { res = true }
    if (pos > 0) {
      if (fields[pos - 1] === ',') { res = true }
    }
    return res
  }

  private isSignedField (name: string): boolean {
    // поле помечается подписанным
    let res = false
    const fields = EPLModule.dicts[this.idx].signedFields
    const pos = fields.indexOf(name)
    if (pos === 0) { res = true }
    if (pos > 0) {
      if (fields[pos - 1] === ',') { res = true }
    }
    // поле помечается подписанным
    return res
  }

  private hidden (item: any): boolean {
    // скрывает поле при определённом значении другого поля
    if (item.hidden !== undefined) {
      const h = item.hidden as string
      const dict = h.split('.')
      return (dict[2].indexOf(EPLModule.dicts[EPLModule.DictIdx(dict[0])].currentRow[dict[1]]) >= 0)
    }
    return false
  }

  private saveEPL (): boolean {
    if (!this.EPLForm.validate()) {
      return false
    }
    if (EPLModule.dicts[this.idx].currentRow.dinnerbegin > EPLModule.dicts[this.idx].currentRow.dinnerend) {
      EPLModule.setError('Некорректное время обеда!')
      return false
    }
    EPLModule.saveDictCurrentRow({ idx: this.idx, hide: false })
      .then(() => {
        this.tablecard++
        this.initEPL()
      })
    // this.savedEPL = JSON.stringify(EPLModule.dicts[this.idx].currentRow)
    // this.changed = false
    return true
  }

  private correctDate (date: number | string) {
    if (date === '' || date === 0) return ''
    if (typeof date === 'string') date = parseInt(date)
    return moment.unix(date).format('DD.MM.YYYY HH:mm')
  }

  private downloadPDF () {
    EPLModule.downloadPDF(EPLModule.dicts[this.idx].currentRow.id)
      .then((response: any) => {
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        let filename = response.headers['content-disposition']
        filename = filename.substr(filename.search(/"/g) + 1)
        filename = filename.substr(0, filename.search(/"/g))
        link.href = url
        link.setAttribute('download', filename)
        document.body.appendChild(link)
        link.click()
      })
  }

  private downloadPDFblank () {
    EPLModule.downloadPDFblank(EPLModule.dicts[this.idx].currentRow.id)
      .then((response: any) => {
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        let filename = response.headers['content-disposition']
        filename = filename.substr(filename.search(/"/g) + 1)
        filename = filename.substr(0, filename.search(/"/g))
        link.href = url
        link.setAttribute('download', filename)
        document.body.appendChild(link)
        link.click()
      })
  }

  private printPDF () {
    EPLModule.downloadPDF(EPLModule.dicts[this.idx].currentRow.id)
      .then((response: any) => {
        const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }))
        const printwWindow = window.open(url)
        setTimeout(() => { if (printwWindow !== null) { printwWindow.print() } }, 300)
      })
  }

  private onGetSignPDF () {
    EPLModule.downloadSigPDF(EPLModule.dicts[this.idx].currentRow.id)
      .then((response: any) => {
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        let filename = response.headers['content-disposition']
        filename = filename.substr(filename.search(/"/g) + 1)
        filename = filename.substr(0, filename.search(/"/g))
        link.href = url
        link.setAttribute('download', filename)
        document.body.appendChild(link)
        link.click()
      })
  }

  private galaxySend () {
    // this.response = ''
    // EPLModule.galaxySend({ beg: this.getUnixTime(this.dateFrom), end: this.getUnixTime(this.dateTo) + 86399 })
    //   .then((response: any) => {
    //     this.response = JSON.stringify(response.data)
    //     const url = window.URL.createObjectURL(new Blob([this.response], { type: 'plain/text' }))
    const link = document.createElement('a')
    // let filename = response.headers['content-disposition']
    // filename = filename.substr(filename.search(/"/g) + 1)
    // filename = filename.substr(0, filename.search(/"/g))
    link.href = `/api/galaxysendbyid/${this.id}`
    link.setAttribute('download', 'galaxy.txt')
    document.body.appendChild(link)
    link.click()
    // })
  }
}
